import { MapLayerType } from '@kinetic-ui/data-layer';
import useMapLayerLogoStyles from './styles';
import { KineticMapContext } from 'components/maps';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import googleLogo from './google_on_white_hdpi.png';

export const MapLayerLogo = () => {
  const classes = useMapLayerLogoStyles();
  const { t } = useTranslation('common');
  const { selectedBaseLayerConfig } = useContext(KineticMapContext);
  let source = selectedBaseLayerConfig?.data?.logo?.base64;

  if (!source) {
    if (selectedBaseLayerConfig?.type !== MapLayerType.Google) {
      return null;
    }
    source = googleLogo;
  }

  return (
    <div className={classes.logo}>
      <img src={source} width='100%' height='100%' alt={t('mapLayerLogo')} />
    </div>
  );
};
